import { render } from "./VehicleDeviationSlider.vue?vue&type=template&id=7c2f3e57"
import script from "./VehicleDeviationSlider.vue?vue&type=script&lang=ts"
export * from "./VehicleDeviationSlider.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea});
